export default __webpack_public_path__ + "static/media/homebanner.da8696fd.jpeg";